'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      rem = _baseTheme$vstui.rem,
      typography = _baseTheme$vstui.typography;
  return (0, _themes.createComponentTheme)(baseTheme, {
    FormControlMessage_fontFamily: typography.fontFamily,
    FormControlMessage_fontSize_small: rem(typography.fontSize - 1),
    FormControlMessage_fontSize_medium: rem(typography.fontSize - 1),
    FormControlMessage_fontSize_large: rem(typography.fontSize),
    FormControlMessage_fontWeight: typography.fontWeightRegular,
    FormControlMessage_color: color.onSurface,
    FormControlMessage_color_disabled: 'rgba(0, 0, 0, 0.57)',
    FormControlMessage_color_error: color.error
  });
};

exports.default = componentTheme;